import AddToCart from './AddToCart';

export default AddToCart;



// WEBPACK FOOTER //
// ./src/components/shared/AddToCart/index.jsx